export default {
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    productFocused() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Focus == null
      ) {
        return true;
      }

      if (this.partnerGroupDetails.Focus === 'Product') {
        return true;
      }

      return false;
    },
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    blogs() {
      return this.$store.getters['user/blogs'];
    },
    promotions() {
      return this.$store.getters['user/promotions'];
    },
    loadingPromotions() {
      return this.$store.getters['user/loadingPromotions'];
    },
  },
  data() {
    return {};
  },
  methods: {},
};
